import React, { useState } from "react";
import Button from "@mui/material/Button";
import {toast, ToastContainer} from "react-toastify";
import http from "./http-common";
import ObjecttypeSelectlist from "./ObjecttypeSelectlist";
import ObjectsSelection from "./ObjectsSelection";
import LoadingIndicator from "./LoadingIndicator";
import {trackPromise} from "react-promise-tracker";

const DropdownWithAutocomplete = ({ TreeSelected, realm, token }) => {
    const [selectedDropdownValue, setSelectedDropdownValue] = useState("");
    const [selectedObjects, setSelectedObjects] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const dropdownOptions = [
        {value: '', text: '-- Bitte wählen Sie einen Objekttypen --'},
        {value: 'Liegenschaft', text: 'Liegenschaft'},
        {value: 'Bauwerk', text: 'Bauwerk'},
        {value: 'Gebäude', text: 'Gebäude'},
        {value: 'Geschoss', text: 'Geschoß'},
        {value: 'Raum', text: 'Raum'},
        {value: 'Spielplatz', text: 'Spielplatz'},
        {value: 'Sportplatz', text: 'Sportplatz'},
        {value: 'Sportfreianlage', text: 'Sportfreianlage'},
        {value: 'Müllstandplatz', text: 'Müllstandplatz'}
    ];

    const downloadTemplate = async () => {
        let formData = new FormData();
        formData.append("realm", realm);
        formData.append("guid", TreeSelected.global_id);
        formData.append("objecttypeguid", selectedDropdownValue);
        formData.append("selectedObjects", JSON.stringify(selectedObjects));
        setIsLoading(true)

        const fetchData = await http.post("/componentType/exportComponenttypeTemplate", formData, {
                headers: {
                    "Content-Type": "application/json"
                },
                responseType: 'blob'
            }
        );

        const url = window.URL.createObjectURL(new Blob([fetchData.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', TreeSelected.name + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoading(false)
        toast('Die Template-Datei wurde in Ihrem Download-Ordner gespeichert.');

    };

    return (
        <>
            <LoadingIndicator/>
        <div style={{textAlign: "left", marginTop:"10px"}}>
            <div style={{margin: "2px"}}>Schränken Sie Ihre Auswahl durch Wahl geeigneter Objekte ein. Z.B. alle Räume in einer Liegenschaft oder einem Gebäude</div>
            <div style={{margin:"2px", display: 'flex'}}>
                <ObjecttypeSelectlist
                    options={dropdownOptions}
                    selected={selectedDropdownValue}
                    handleChange={(e) => setSelectedDropdownValue(e.target.value)}
                    style={{minWidth:"200px", height:"46px"}}
                    label="Immobilienobjekt"
                    variant="outlined"
                    color="primary"
                />
                <Button type="button"
                        color="primary"
                        variant="outlined"
                        onClick={() => setShowTable(true)}
                        style={{margin: "9px 20px", height:"45px"}}
                >Objekte auswählen</Button>

            </div>
            <div style={{margin:"10px"}}>
                <Button type="button" color="primary" variant="outlined" size="large" onClick={()=>trackPromise(downloadTemplate())}>Export Bauteiltyp-Template</Button>
            </div>
        </div>
        {showTable && (
            <ObjectsSelection realm={realm} setSelectedObjects={setSelectedObjects} setShowTable={setShowTable}/>
        )}
        <ToastContainer />
        </>
    );
};

export default DropdownWithAutocomplete;
